import React, {ReactNode, ReactNodeArray, CSSProperties} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import ChangePricePlanMarketBlockData from '../../../Models/Content/ChangePricePlanMarketBlockData';
import ChangePricePlanMarketMain from './ChangePricePlanMarketMain';
import '../ChangePricePlanBlock/changePricePlan.scss';

export default class ChangePricePlanMarketBlock extends EpiComponent<ChangePricePlanMarketBlockData> {
  public render(): null | ReactNode | ReactNodeArray {
    return (
      <div>
        <ChangePricePlanMarketMain context={this.getContext()} iContent={this.props.data} />
      </div>
    );
  }
}
